module.exports = __webpack_public_path__ + "static/media/logo-white.02b5f6d5.svg";